import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { CustomCotationFormData } from "@/types/forms/home/customCotationsForm.form";
import StyledSpinner from "@/components/styled/StyledSpinner";
import { GetAllCompanyDto } from "@/types/api/api-types";
import { StyledSelectSingleValue } from "@/components/styled/StyledSelectSingleValue";
import StyledInput from "../styled/StyledInput";
import { CreditCard } from "lucide-react";

interface InfoValidationProps {
  billingEntities: GetAllCompanyDto["billingEntities"];
  isLoading: boolean;
}

export const InfoValidationOther = ({ billingEntities, isLoading }: InfoValidationProps) => {
  const { t } = useTranslation("boQuotations");
  const methods = useFormContext<CustomCotationFormData>();

  return (
    <div className="flex w-full flex-1 flex-col items-center gap-6">
      <div className="flex w-full max-w-[800px] flex-col items-center justify-center gap-4 rounded-xl border border-gray-200 bg-white p-6">
        <div className="flex flex-row items-start justify-start gap-4 self-start">
          <CreditCard />
          <h2 className="text-xm font-semibold text-black">{t("validationOther.title")}</h2>
        </div>
        <div className="flex w-full flex-col gap-2">
          <StyledSelectSingleValue
            options={
              billingEntities.map((billingEntity) => ({
                value: billingEntity.id,
                label: billingEntity.companyName,
              })) || []
            }
            setValue={(e: any) => methods.setValue("billingEntityId", e || "")}
            title={t("validationOther.billingEntityLabel")}
            control={methods.control}
            name="billingEntityId"
            className="w-full"
          />
          <StyledInput
            control={methods.control}
            name="reference"
            title={t("validationOther.referenceLabel")}
            className="w-full"
          />
        </div>
      </div>
      <div className="flex w-full max-w-[800px] flex-col-reverse gap-3 md:flex-row">
        <button
          disabled={isLoading}
          className="text-normal bg-brand700 hover:bg-brand600 flex-1 px-4 py-2 font-semibold text-white disabled:bg-gray-200 disabled:text-gray-500"
        >
          {isLoading ? <StyledSpinner width="20" height="20" /> : t("validationOther.submit")}
        </button>
      </div>
    </div>
  );
};
